import { Component, Input } from '@angular/core';
@Component({
  selector: 'cs-info',
  standalone: false,
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent {
  public displayDropDown = false;
  @Input()
  public icon: string = 'information';

  public openDropDown(): void {
    this.displayDropDown = !this.displayDropDown;
  }

  public backDropClick(): void {
    this.displayDropDown = false;
  }
}
